// File: app.routing.ts
// Author: Joseph M Diaz
// Date: 4/24/2017
// Desc: Root routing for the app.
// Other Contributors:

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { panelbarRouting, appRoutingProviders } from './app-routing.module';
import { AuthenticationService } from './auth.service';
import { HomeComponent } from './home/home.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UsersComponent } from './components/mesc/administration/security/users/users.component';

const appRoutes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'logged-out', component: LoggedOutComponent },
    { path: '', pathMatch: 'full', redirectTo: '/home' },
    { path: '**', component: NotFoundComponent }
]

@NgModule({
    imports: [
        panelbarRouting,
        RouterModule
        // RouterModule.forRoot(appRoutes, { useHash: true })
    ],
    exports: [
        RouterModule
    ],
    providers: [
        appRoutingProviders,
    ]
})
export class AppRoutingModule { };